








import BaseComponent from "@/components/BaseComponent.vue";
import app from "@/app";
import { Component } from "vue-property-decorator";

@Component
export default class PUserSignup extends BaseComponent {
	get step() {
		let step = app.store.routeContext.getToken("step") || "one";
		return ({ one: 1, two: 2, three: 3 } as any)[step];
	}

	routes() {
		return { list: [2, 5, 4] };
	}
}
